import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useStaffMembers = () => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["staffMembers", tenantVal],
    queryFn: async () => {
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.get(`${tenantVal}/staffmember`);
      return response.data;
    },
    enabled: !!tenantVal,
    meta: { errorMessage: "Error fetching staff members" },
   
    staleTime: 1000 * 60 * 5,
    // Background refresh so the chat sidebar drops disabled users (and
    // picks up new joiners) without needing a full page reload.
    // 60s is cheap (single small GET) and quiet enough not to thrash
    // other consumers.
    refetchInterval: 1000 * 60,
    refetchOnWindowFocus: true,
  });
};
